import React from 'react';
import { SVGProps } from './SVGProps';
import classnames from 'classnames';

/**
 * Lock SVG component
 *
 * @returns
 */
function LockSVG({ className, ...rest }: SVGProps) {
	return (
		<svg
			viewBox="0 0 27 32"
			className={classnames('roc-icon roc-icon-lock', className)}
			focusable="false"
			aria-hidden="true"
			{...rest}
		>
			<path d="M24.454 14.487h-0.752v-4.385c-0.099-5.608-4.714-10.102-10.374-10.102s-10.275 4.495-10.374 10.102v4.385h-0.743c-1.222 0-2.212 0.982-2.212 2.192v13.129c0 1.211 0.99 2.192 2.212 2.192h22.242c1.222 0 2.212-0.982 2.212-2.192v-13.132c-0.002-1.21-0.992-2.189-2.212-2.189zM19.278 14.487h-11.867v-4.385c0.074-3.191 2.706-5.74 5.927-5.74s5.853 2.549 5.927 5.74l0.013 4.385z" />
		</svg>
	);
}

export default LockSVG;
